import { render, staticRenderFns } from "./AbgeschlosseneBestellungen.vue?vue&type=template&id=3c9a8348"
import script from "./AbgeschlosseneBestellungen.vue?vue&type=script&lang=ts"
export * from "./AbgeschlosseneBestellungen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports